import { Component, Input } from '@angular/core';

@Component({
  selector: 'xt-portal-tags',
  templateUrl: './tags.component.html',
  styleUrls: ['./tags.component.scss'],
    standalone: false
})
export class TagsComponent {
  @Input() text;
  @Input() color: 'light-blue' | 'yellow' | 'green' | 'red' | 'white' | 'grey' =
    'light-blue';
}
